import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import DocumentComp from "./Component/DocumentComp"


const Document =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <DocumentComp />
        </div>
        <Footer />
        </>
    )
}

export default Document